import { render, staticRenderFns } from "./index.vue?vue&type=template&id=754eddc3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=754eddc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754eddc3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/app/components/Loading.vue').default,CollectionPageStructuredData: require('/app/components/CollectionPageStructuredData.vue').default,DealList: require('/app/components/DealList.vue').default})
